import { useMediaAdCampaignRemoveMutation } from '@shared/api/graphql/generated';
import { BaseMutationResultType, FetchPolicyKeys } from '@shared/api/graphql/types';

export type UseAdCampaignRemoveResultType = BaseMutationResultType;

export type UseAdCampaignRemoveType = [
  request: (adCompanyId: string) => Promise<boolean>,
  result: UseAdCampaignRemoveResultType,
];

const useAdCampaignRemove = (): UseAdCampaignRemoveType => {
  const [removeMutation, removeMutationResult] = useMediaAdCampaignRemoveMutation({
    fetchPolicy: FetchPolicyKeys.NETWORK_ONLY,
  });

  const request = async (adCompanyId: string) => {
    const removedAdCampaign = await removeMutation({
      variables: {
        input: {
          adCompanyId,
        },
      },
      refetchQueries: ['mediaAdCampaignsPaginationQuery'],
    });

    return !!removedAdCampaign.data?.result?.ok;
  };

  const result: UseAdCampaignRemoveResultType = {
    error: removeMutationResult.error,
    loading: removeMutationResult.loading,
    called: removeMutationResult.called,
  };

  return [request, result];
};

export default useAdCampaignRemove;
